"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductCodes = void 0;
var _tsUtils = require("@ori/ts-utils");
const getProductCodes = products => products?.map(productBox => productBox?.productCode).filter(_tsUtils.isNonNullable) ?? [];
exports.getProductCodes = getProductCodes;
